import React from "react";
import { Dialog, FlatButton, RaisedButton } from "material-ui";
import { Link } from "react-router";

import config from "../config";
import UserStore from "../stores/UserStore";
import InfoNotice from "./partials/info-notice.jsx";

class BallotingApp extends React.Component {
  static contextTypes = {
    router: React.PropTypes.object
  };

  getStyles() {
    return {
      image: {
        width: "100%",
        maxWidth: 250,
        border: "1px solid #ccc"
      },
      installLink: {}
    };
  }

  getBallotImgUrl() {
    return `${
      config.endpoint
    }users/self/api_keys/qr.svg?${UserStore.makeApiKeyQueryString()}&scope=ballot-entry`;
  }

  render() {
    const styles = this.getStyles();

    return (
      <div>
        <p>
          Use the Eventive Ballot app, available for iOS and Android, to collect
          votes at the door after screenings.
          <br />
          We recommend using a tablet (especially for programs with multiple
          films), but a smaller device works too.
          <br />
          Collect votes with as many devices as you'd like at each screening.
          All votes will be recorded instantly.
        </p>
        <InfoNotice style={{ marginBottom: "1.5em", fontSize: "10pt" }}>
          Check out our{" "}
          <a
            href="https://help.eventive.org/eventive-balloting/using-app-based-voting"
            target="_blank"
          >
            guide to using the Eventive Ballot app
          </a>
          .
        </InfoNotice>
        <p style={{ margin: "-10px 0", minHeight: 58 }}>
          <a
            style={styles.installLink}
            href="https://itunes.apple.com/US/app/id1447062011?mt=8"
            target="_blank"
          >
            <img
              src="/img/download-on-app-store.svg"
              style={{ width: 130, verticalAlign: "middle" }}
            />
          </a>
          <a
            style={styles.installLink}
            href="https://play.google.com/store/apps/details?id=org.eventive.eventiveballot"
            target="_blank"
          >
            <img
              alt="Get it on Google Play"
              src="https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png"
              style={{ width: 150, verticalAlign: "middle" }}
            />
          </a>
        </p>
        <p>
          After installing Eventive Ballot, scan the code below to login as{" "}
          {(UserStore.getUser() || { organization: "" }).organization}.
        </p>
        <img style={styles.image} src={this.getBallotImgUrl()} />
      </div>
    );
  }
}

export default BallotingApp;



// WEBPACK FOOTER //
// ./src/app/components/balloting-app.jsx